var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInfoTooltip = function SvgInfoTooltip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_186",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 186",
    transform: "translate(-376 -747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_80",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 80",
    transform: "translate(376 747)",
    fill: "none",
    stroke: "#0067b9",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_157",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 157",
    transform: "translate(1879.223 -9641.982) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_145",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 145",
    transform: "translate(1492.199 -10404.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_129",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 129",
    d: "M6.5,9.677a.912.912,0,0,1-.913-.913V4.738a.913.913,0,1,1,1.826,0V8.764A.912.912,0,0,1,6.5,9.677Z",
    transform: "translate(-5.585 -3.825)",
    fill: "#0067b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_146",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 146",
    transform: "translate(1492.016 -10396.144)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_79",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 79",
    cx: 1.095,
    cy: 1.095,
    r: 1.095,
    fill: "#0067b9"
  }))))));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyBpZD0i0KHQs9GA0YPQv9C/0LjRgNC+0LLQsNGC0YxfMTg2IiBkYXRhLW5hbWU9ItCh0LPRgNGD0L/Qv9C40YDQvtCy0LDRgtGMIDE4NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM3NiAtNzQ3KSI+DQogICAgICAgIDxnIGlkPSLQrdC70LvQuNC/0YFfODAiIGRhdGEtbmFtZT0i0K3Qu9C70LjQv9GBIDgwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNzYgNzQ3KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDA2N2I5IiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICAgICAgPGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiIHN0cm9rZT0ibm9uZSIvPg0KICAgICAgICAgICAgPGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iOSIgZmlsbD0ibm9uZSIvPg0KICAgICAgICA8L2c+DQogICAgICAgIDxnIGlkPSLQodCz0YDRg9C/0L/QuNGA0L7QstCw0YLRjF8xNTciIGRhdGEtbmFtZT0i0KHQs9GA0YPQv9C/0LjRgNC+0LLQsNGC0YwgMTU3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODc5LjIyMyAtOTY0MS45ODIpIHJvdGF0ZSgxODApIj4NCiAgICAgICAgICAgIDxnIGlkPSLQodCz0YDRg9C/0L/QuNGA0L7QstCw0YLRjF8xNDUiIGRhdGEtbmFtZT0i0KHQs9GA0YPQv9C/0LjRgNC+0LLQsNGC0YwgMTQ1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDkyLjE5OSAtMTA0MDQuMDI5KSI+DQogICAgICAgICAgICAgICAgPHBhdGggaWQ9ItCa0L7QvdGC0YPRgF8xMjkiIGRhdGEtbmFtZT0i0JrQvtC90YLRg9GAIDEyOSIgZD0iTTYuNSw5LjY3N2EuOTEyLjkxMiwwLDAsMS0uOTEzLS45MTNWNC43MzhhLjkxMy45MTMsMCwxLDEsMS44MjYsMFY4Ljc2NEEuOTEyLjkxMiwwLDAsMSw2LjUsOS42NzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNS41ODUgLTMuODI1KSIgZmlsbD0iIzAwNjdiOSIvPg0KICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgPGcgaWQ9ItCh0LPRgNGD0L/Qv9C40YDQvtCy0LDRgtGMXzE0NiIgZGF0YS1uYW1lPSLQodCz0YDRg9C/0L/QuNGA0L7QstCw0YLRjCAxNDYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0OTIuMDE2IC0xMDM5Ni4xNDQpIj4NCiAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSLQrdC70LvQuNC/0YFfNzkiIGRhdGEtbmFtZT0i0K3Qu9C70LjQv9GBIDc5IiBjeD0iMS4wOTUiIGN5PSIxLjA5NSIgcj0iMS4wOTUiIGZpbGw9IiMwMDY3YjkiLz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg0K";
export { SvgInfoTooltip as ReactComponent };